export const ERROR_HTTP_500 = "Une erreur s'est produite. Veuillez réessayer plus tard.";
